import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { numberFormatter } from "@common/helpers/number";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AgentUsageRow } from "../agentUsageRow";
import styles from "./Cells.module.scss";

export const NumberCell = memo(
    ({ getValue }: CellContext<ViewTableFeatures, AgentUsageRow, number>) => (
        <ViewTableCell className={styles.numberCell}>
            {numberFormatter.format(getValue())}
        </ViewTableCell>
    ),
);

NumberCell.displayName = "NumberCell";
